<form id="busy-form" action="#" method="POST" soho-busyindicator
    [transparentOverlay]="transparentOverlay" [blockUI]="true" [text]="message" [displayDelay]="delay"
    autocomplete="off">
    <div id="notification">
    </div>
    <div class="row" style="padding-top:1%; padding-left:1%;">
        <h2 class="fieldset-title" style="font-size: x-large;">{{ProjectTitle}}</h2>
    </div>
    <div class="row">
        <div class="twelve columns">
            <div class="six columns" style="padding-left: 4%;padding-top: 3%;">
                <div class="row top-padding">
                    <div class="field" id="divroletype">
                        <label id="tblroletype" class="required" for="roletype">Role Type</label>
                        <input id="roletype" name="roletype" type="text" data-validate="required" soho-input
                            (click)="RemoveError('roletype')" [(ngModel)]="model.roletype" />
                    </div>
                </div>
                <div class="field" id="divpaycurve1">
                    <label id="tblpaycurve1" for="paycurve1">Pay Curve 1</label>
                    <input id="paycurve1" name="paycurve1" type="text" soho-input
                        (click)="RemoveError('paycurve1')" [(ngModel)]="model.paycurve1" />
                </div>
                <div class="field" id="divpaycurve2">
                    <label id="tblpaycurve2" for="paycurve2">Pay Curve 2</label>
                    <input id="paycurve2" name="paycurve2" type="text" soho-input
                        (click)="RemoveError('paycurve2')" [(ngModel)]="model.paycurve2" />
                </div>
                <div class="field" id="divpaycurve3">
                    <label id="tblpaycurve3" for="paycurve3">Pay Curve 3</label>
                    <input id="paycurve3" name="paycurve3" type="text" soho-input
                        (click)="RemoveError('paycurve3')" [(ngModel)]="model.paycurve3" />
                </div>
                <div class="field" id="divpaycurve4">
                    <label id="tblpaycurve4" for="paycurve4">Pay Curve 4</label>
                    <input id="paycurve4" name="paycurve4" type="text" soho-input
                        (click)="RemoveError('paycurve4')" [(ngModel)]="model.paycurve4" />
                </div>
                <div class="field" id="divpaycurve5">
                    <label id="tblpaycurve5" for="paycurve5">Pay Curve 5</label>
                    <input id="paycurve5" name="paycurve5" type="text" soho-input
                        (click)="RemoveError('paycurve5')" [(ngModel)]="model.paycurve5" />
                </div>
            </div>
        </div>
        <div class="row" id="EditDetails" style="text-align: center;padding-top: 2%;" class=" twelve columns">
            <button class="btn-primary hide-focus" type="button" title="UpdateMapping" (click)="UpdateMapping()">Update</button>&nbsp;
            <button class="btn-secondary hide-focus" type="button" title="DeleteMapping" (click)="ShowConfirmDelete()">Delete</button>&nbsp;
            <button class="btn-secondary hide-focus" type="button" title="Cancel" (click)="Cancel()">Cancel</button>
        </div>
    </div>
</form>
